import App from "../index";
import {getEl, isGreaterThanOrEqualTo, isSmallerThanOrEqualTo} from "../helpers";

export enum ResponsiveSize
{
	none = '',
	xs = 'xs',
	sm = 'sm',
	md = 'md',
	lg = 'lg',
	xl = 'xl',
	xxl = 'xxl',
}

export default class ResponsiveWatcher
{
	//I cant think of any way to get the SASS variables into this file
	//So if you change the breakpoints in the SASS, you will have to manually update them here.
	static breakpoints: {[key in ResponsiveSize]?:number} = {
		xs: 0,
		sm: 576,
		md: 768,
		lg: 992,
		xl: 1200,
		xxl: 1460
	};
	
	static ordering: ResponsiveSize[] = [ResponsiveSize.xs, ResponsiveSize.sm, ResponsiveSize.md, ResponsiveSize.lg, ResponsiveSize.xl, ResponsiveSize.xxl];
	
	queries: {min:number, max: number, query: MediaQueryList, name: ResponsiveSize}[] = [];
	app:App;
	
	currentSize:ResponsiveSize = ResponsiveSize.none;
	currentIndex:number = -1;
	
	constructor(app:App) {
		this.app = app;
		
		this.onMediaChange = this.onMediaChange.bind(this);
		
		for (let key in ResponsiveWatcher.breakpoints)
		{
			this.queries.push({
				min: ResponsiveWatcher.breakpoints[key],
				max: 0,
				name: ResponsiveSize[key],
				query: null,
			});
		}
		
		this.queries.sort((a,b) => a.min - b.min);
		
		for (let i= 0; i < this.queries.length; i++)
		{
			this.queries[i].max = i == this.queries.length-1 ? 0 : this.queries[i+1].min-0.2;
			let querystr = '';
			if (this.queries[i].min == 0) {
				querystr = `(max-width: ${this.queries[i].max}px)`;
			} else if (this.queries[i].max == 0) {
				querystr = `(min-width: ${this.queries[i].min}px)`;
			} else {
				querystr = `(min-width: ${this.queries[i].min}px) and (max-width: ${this.queries[i].max}px)`;
			}
			this.queries[i].query = window.matchMedia(querystr);
			this.queries[i].query.addEventListener('change', this.onMediaChange);
			//console.log(this.queries[i], ' = ', querystr);
		}
		
		this.onMediaChange();
	}
	
	
	public isSmallerOrEqualTo(benchmark:ResponsiveSize)
	{
		return isSmallerThanOrEqualTo(this.currentSize, benchmark);
	}
	
	public isGreaterThanOrEqualTo(benchmark:ResponsiveSize)
	{
		return isGreaterThanOrEqualTo(this.currentSize, benchmark);
	}
	
	public onMediaChange()
	{
		const oldSize = this.currentSize;
		
		this.currentSize = ResponsiveSize.none;
		this.currentIndex = -1;
		for (let i = 0; i < this.queries.length; i++)
		{
			if (this.queries[i].query.matches) {
				this.currentSize = this.queries[i].name;
				this.currentIndex = i;
				break;
			}
		}
		
		if (this.currentSize != oldSize) {
			//console.log("Media changed! Old: ", oldSize, " - New: ", this.currentSize);
			const el = getEl('#slb-report');
			if (oldSize) el.classList.remove(oldSize);
			if (this.currentSize) el.classList.add(this.currentSize);
			document.dispatchEvent(new CustomEvent('responsivechange', {detail: {old: oldSize, new: this.currentSize}}));
		}
	}
}
